import { StatRow } from 'oas';
import { getUniqueAthleteCount } from './get-unique-athlete-count';
import { getStatsTransformStrategy } from '../strategies/transform';
import { TfParameter } from 'api';

// transforms normalised stats to form we care about (average per athlete per day, week, etc.)
export const averageNormalisedStatsPerAthlete = (
    stats: StatRow[],
    parameters: TfParameter[],
    shouldUseTotalValues?: boolean,
    acRatioAverageOverride?: boolean,
): StatRow[] =>
    stats.map((stat) => {
        const uniqueAthleteCount = getUniqueAthleteCount(stat) || 1;

        const averagedStat: StatRow = { ...stat };

        parameters.forEach((param) => {
            const strat = getStatsTransformStrategy(param?.aggregation ?? '');

            const value = stat[param?.slug] ?? 0;

            averagedStat[param?.slug] = shouldUseTotalValues
                ? value
                : strat.applyAverage(value, uniqueAthleteCount, param?.group_by ?? '');

            // for AC ratio, we want to average per activity after normalisation & averaging per athlete
            if (acRatioAverageOverride) {
                averagedStat[param?.slug] = averagedStat[param?.slug] / (stat['activity_count'] || 1);
            }
        });

        return averagedStat;
    });
